import App from './app'

const app = new App()